import React from "react";
import { PREVIEW_BAR_SPACING, PreviewBar } from "../../preview/PreviewBar";
import { Box, useTheme } from "@mui/material";
import { PreviewBox } from "../../preview/PreviewBox";
import makeStyles from "@mui/styles/makeStyles";
import ClientDetails from "../../coach-clients/ClientDetails";
import { ClientContext } from "../../../hooks/useClient";
import { useQuery } from "@tanstack/react-query";
import { COACH_CLIENT_GENERIC_QUERY_KEY } from "../../../wrappers/router/coach/CoachClientProfileWrapper";
import ClientsService from "../../../services/ClientsService";
import { DefaultLoader } from "../../loading/DefaultLoader";
import { ProfileCardPosition } from "./utils";

const useStyles = makeStyles((theme) => ({
  previewContainer: {
    padding: theme.spacing(2, 0),
    maxWidth: 1100,
    marginInline: "auto",
    pointerEvents: "none",
    containerType: "inline-size",
  },
}));

interface ProfilePreviewProps {
  positions?: ProfileCardPosition[];
  username: string;
}

export const ProfilePreview = (props: ProfilePreviewProps) => {
  const theme = useTheme();
  const s = useStyles();
  const { positions, username } = props;

  const { data: client, isLoading } = useQuery({
    queryKey: [COACH_CLIENT_GENERIC_QUERY_KEY, { username }],
    queryFn: () => ClientsService.getBriefClientInfo(username),
    enabled: !!username,
  });

  return (
    <ClientContext.Provider value={client}>
      {isLoading ? (
        <DefaultLoader fillScreen />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pt: theme.spacing(PREVIEW_BAR_SPACING),
            height: "100vh",
            width: "100%",
            my: "auto",
          }}
        >
          <PreviewBar />
          <PreviewBox contentPaddingInline={0}>
            <Box className={s.previewContainer}>
              <ClientDetails positions={positions} isPreview />
            </Box>
          </PreviewBox>
        </Box>
      )}
    </ClientContext.Provider>
  );
};
